import React, { useState } from "react";
import { Link } from "react-router-dom";

interface IProps {
    title: string;
    link: string;
    tabNo: string;
    selectedTab: string;
}

const TabItem: React.FunctionComponent<IProps> = (props) => {
    const [currentTab, setCurrentTab] = useState(props.selectedTab);

    function handleClick(e: any) {
        setCurrentTab(e.currentTarget.id.toString());
    }

    return (
        <li className="tab-item" role="menuitem" onClick={handleClick} id={props.tabNo} aria-label={props.title}>
            <Link
                to={props.link}
                onClick={() => window.addToDataLayer({ event: "Sub Page Nav " + props.title })}
                className={"btn-default btn-tab " + (props.tabNo === currentTab ? "tab-active" : "")}
                aria-current={props.tabNo === currentTab ? "page" : "false"}
                tabIndex={props.tabNo === currentTab ? -1 : 0}
            >
                <span className="btn-text">{props.title}</span>
            </Link>
        </li>
    );
};

export default TabItem;
